/* eslint-disable no-console */
import { useMemo } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { Panel, ButtonToolbar, Col } from 'rsuite'
import { Formik, Form, FormikHelpers, FormikProps, Field } from 'formik'
import { notifyError, notifySuccess } from 'utils'
import { Button, FormikErrorMessage, Row, Section, TextInput } from 'shared'
import useAuth from '../../hooks/Auth'
import {
  HelpForm,
  defaultHelpFormValues,
  helpFormValidationSchema,
  HELP_FORM_FIELDS
} from './utils'
import './Help.scss'
import { useCreateEnquiryMutation } from './helpApiSlice'
import { Enquiries } from './types'

const EnquiryForm = () => {
  const initialValues = useMemo(() => ({ ...defaultHelpFormValues }), [])
  const [createEnquiry] = useCreateEnquiryMutation()
  const { loginUserDetails, setopenEditProfile, isSubsId } = useAuth()
  const id = loginUserDetails?.id
  const onSubmit = async (
    formValues: HelpForm,
    { setSubmitting, resetForm }: FormikHelpers<HelpForm>
  ) => {
    if (!isSubsId) {
      setopenEditProfile(true)
    } else {
      const enquiryDTO: Enquiries = {
        fullName: formValues.fullName,
        mobile: formValues.mobile,
        email: formValues.email,
        message: formValues.message,
        userDTO: {
          id: Number(id) ?? 0
        }
      }
      try {
        await createEnquiry({ enquiryDTO }).unwrap()
        notifySuccess('Enquiry sent successfully!')
        resetForm()
      } catch (error) {
        notifyError('Failed to send Enquiry')
      } finally {
        setSubmitting(false)
      }
    }
  }
  const renderFormButtons = (formikProps: FormikProps<HelpForm>) => (
    <ButtonToolbar>
      <Button
        className="formButton"
        id="reset"
        onClick={() => {
          formikProps.resetForm()
        }}
      >
        Reset
      </Button>
      <Button
        className="formButton"
        appearance="primary"
        type="submit"
        disabled={formikProps.isValidating ?? formikProps.isSubmitting}
      >
        Save
      </Button>
    </ButtonToolbar>
  )

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={helpFormValidationSchema}
        onSubmit={onSubmit}
      >
        {(formikProps: FormikProps<HelpForm>) => (
          <Form className="enquiry">
            <Panel>
              <Section title="Enquiry Details">
                <Row>
                  <Col xs={12}>
                    <TextInput
                      formik={formikProps}
                      name={HELP_FORM_FIELDS.FULLNAME}
                      placeholder="Enter your name"
                    />
                    <FormikErrorMessage name={HELP_FORM_FIELDS.FULLNAME} />
                  </Col>
                  <Col xs={12}>
                    <TextInput
                      formik={formikProps}
                      name={HELP_FORM_FIELDS.EMAIL}
                      placeholder="Enter your email"
                    />
                    <FormikErrorMessage name={HELP_FORM_FIELDS.EMAIL} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <div className="phone_number">
                      <PhoneInput
                        country="in"
                        value={formikProps.values[HELP_FORM_FIELDS.MOBILE]}
                        onChange={(phone) =>
                          formikProps.setFieldValue(
                            HELP_FORM_FIELDS.MOBILE,
                            phone
                          )
                        }
                        inputClass="phone-input"
                        containerClass="phone-input-container"
                      />
                    </div>

                    <FormikErrorMessage name={HELP_FORM_FIELDS.MOBILE} />
                  </Col>
                  <Col md={12}>
                    <Field
                      as="textarea"
                      rows={2}
                      name={HELP_FORM_FIELDS.MESSAGE}
                      placeholder="Enter Enquiry Message"
                      className="rs-input text-area-input"
                    />
                    <FormikErrorMessage name={HELP_FORM_FIELDS.MESSAGE} />
                  </Col>
                </Row>
              </Section>
              <Panel className="panel-buttons">
                {renderFormButtons(formikProps)}
              </Panel>
            </Panel>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default EnquiryForm
